import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Agreement.Agreement_Minimal}
    mutation UpdateAgreement(
        $id: ID!
        $enterpriseId: ID!
        $title: String!
        $description: String
        $startAt: String
        $endAt: String
        $amount: Float
        $category: EnumAgreementCategory
        $file: String
    ) {
        updateAgreement(
            input: {
                id: $id
                enterpriseId: $enterpriseId
                title: $title
                description: $description
                startAt: $startAt
                endAt: $endAt
                amount: $amount
                category: $category
                file: $file
            }
        ) {
            errors
            status
            statusCode
            agreement {
                ...Agreement_Minimal
            }
        }
    }
`
